import { MailWhiteIcon } from 'src/components/Icons/MailWhiteIcon'
import { WhatsAppWhiteIcon } from 'src/components/Icons/WhatsAppWhiteIcon'
import { Image } from 'src/components/ui/Image'

interface InsuranceSantuuFooterProps {
  title: string
  phoneNumber: string
  email: string
  logoMobile: string
  logoDesktop: string
  description: string
}

const InsuranceSantuuFooter: React.FC<InsuranceSantuuFooterProps> = ({
  title,
  phoneNumber,
  email,
  logoMobile,
  logoDesktop,
  description,
}) => {
  return (
    <footer className="bg-[#101010] text-white w-full">
      <div className="max-w-[1440px] mx-auto px-6 py-10 flex flex-col md:flex-row md:justify-between gap-10">
        <div className="flex flex-col gap-4 md:w-1/3">
          <h2 className="text-font-size-8 md:font-bold font-medium">{title}</h2>
          <div className="flex flex-col gap-3 text-sm">
            <div className="flex items-center gap-2">
              <span className="h-4 w-4">
                <WhatsAppWhiteIcon />
              </span>
              <span className="text-white text-sm font-normal">
                {phoneNumber}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-4 w-4">
                <MailWhiteIcon />
              </span>
              <span className="text-white text-sm font-normal">{email}</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6 md:w-2/3">
          <div className="flex flex-wrap items-center justify-center md:justify-start w-full gap-8">
            <Image
              src={logoMobile ?? logoDesktop}
              srcSet={
                logoMobile && logoDesktop
                  ? `${logoMobile} 767w, ${logoDesktop} 768w`
                  : undefined
              }
              alt="Logo Desktop"
              className="text-center md:h-[70px] h-auto w-full md:w-[734px] object-contain"
            />
          </div>
          <p className="text-xs text-white font-normal leading-5 text-left">
            {description}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default InsuranceSantuuFooter
